<template>
  <el-form :model="customer" label-width="80px" :loading="loading">
    <el-form-item label="姓名" required>
      <el-input placeholder="请输入姓名" v-model="customer.name"/>
    </el-form-item>
    <el-form-item label="手机号">
      <el-input placeholder="如果会员是未成年,建议一定添加联系人" v-model="customer.phone"/>
    </el-form-item>
    <el-form-item label="性别" required>
      <el-select v-model="customer.gender" placeholder="请选择性别">
        <el-option
          v-for="item in genderType"
          :key="item.id"
          :label="item.text"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="身份证">
      <el-input placeholder="请输入身份证" v-model="customer.idCard"/>
    </el-form-item>
    <el-form-item label="出生日期">
      <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="customer.birthday"/>
    </el-form-item>
    <el-form-item label="邮箱">
      <el-input placeholder="请输入邮箱" v-model="customer.email"/>
    </el-form-item>
    <el-form-item label="地址">
      <el-input placeholder="请输入地址" v-model="customer.address"/>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="customer.remark" multiline/>
    </el-form-item>
    <el-form-item v-for="(item, index) in customer.contacts" :key="index" :label="'联系人' + (index + 1)">
      <div style="display: flex; align-items: start">
        <div>
          <el-form-item label="姓名" required>
            <el-input placeholder="请输入姓名" v-model="item.name" />
          </el-form-item>
          <el-form-item label="角色" style="margin-top: 10px" required>
            <el-input placeholder="比如爸爸,妈妈,爷爷,奶奶" v-model="item.role"/>
          </el-form-item>
          <el-form-item label="手机号" style="margin-top: 10px" required>
            <el-input placeholder="请输入手机号" v-model="item.phone"/>
          </el-form-item>
        </div>
        <el-button style="margin-left: 10px" @click="deleteContact(index)">删除</el-button>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitSaveAction">确 定</el-button>
      <el-button type="primary" @click="addContact">添加联系人</el-button>
      <el-button @click="close">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {add, update} from './customerApi'

export default {
  name: 'addOrEditCustomer',
  data () {
    return {
      loading: false,
      customer: {
        phone: '',
        email: '',
        name: '',
        idCard: '',
        birthday: null,
        address: '',
        remark: '',
        contacts: []
      },
      genderType: [
        {
          id: 1,
          text: '男'
        },
        {
          id: 2,
          text: '女'
        }
      ],
      addOrEdit: true
    }
  },
  props: {
    data: {
      phone: '',
      email: '',
      name: '',
      idCard: '',
      birthday: null,
      address: '',
      remark: '',
      contacts: []
    }
  },
  created () {
    if (this.data !== undefined && this.data !== null) {
      const copy = JSON.parse(JSON.stringify(this.data))
      const { customerId } = copy
      this.addOrEdit = customerId === undefined
      if (copy.contacts == null) {
        copy.contacts = []
      }
      this.customer = copy
    }
  },
  watch: {
    data (d) {
      const copy = JSON.parse(JSON.stringify(d))
      const { customerId } = copy
      this.addOrEdit = customerId === undefined
      if (copy.contacts == null) {
        copy.contacts = []
      }
      this.customer = copy
    }
  },
  methods: {
    submitSaveAction () {
      if (this.addOrEdit === true) {
        this.submitAddAction()
      } else {
        this.submitUpdateCustomer()
      }
    },
    submitAddAction () {
      const name = this.customer.name.trim()
      if (name.length === 0) {
        this.$message.error('姓名不能为空')
        return
      }
      const { contacts } = this.customer
      if (contacts && contacts.length > 0) {
        for (let i = 0; i < contacts.length; i++) {
          const tempContact = contacts[i]
          const name = tempContact.name.trim()
          if (name.length === 0) {
            this.$message.error('联系人' + (i + 1) + '姓名不能为空')
            return
          }
          const role = tempContact.role.trim()
          if (role.length === 0) {
            this.$message.error('联系人' + (i + 1) + '称呼不能为空')
            return
          }
          const phone = tempContact.phone.trim()
          if (phone.length === 0) {
            this.$message.error('联系人' + (i + 1) + '手机不能为空')
            return
          }
        }
      }
      this.loading = true
      add(this.customer).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('添加成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdateCustomer () {
      this.loading = true
      update(this.customer).catch(() => {
        this.loading = false
      }).then((rsp) => {
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      })
    },
    close () {
      this.$emit('close')
    },
    addContact () {
      const item = {}
      item.phone = ''
      item.name = ''
      item.role = ''
      this.customer.contacts.push(item)
    },
    deleteContact (index) {
      this.customer.contacts.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customer/addOrEditCustomer.vue